module.exports = __webpack_public_path__ + "img/shoot-4.a3132c62.jpg";